import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "utc-subtitle" }, "Thông tin thí sinh", -1)
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row flex-wrap justify-content-end gap-2"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Mã hồ sơ", -1)
const _hoisted_8 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Tình trạng nộp lệ phí", -1)
const _hoisted_10 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200 font-medium" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Mã thanh toán lệ phí xét tuyển", -1)
const _hoisted_12 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Ghi chú", -1)
const _hoisted_14 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Họ, chữ đệm và tên của thí sinh", -1)
const _hoisted_17 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Căn cước công dân", -1)
const _hoisted_19 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Ngày cấp", -1)
const _hoisted_21 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Nơi cấp", -1)
const _hoisted_23 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Giới tính", -1)
const _hoisted_25 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Ngày/tháng/năm sinh", -1)
const _hoisted_27 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Nơi sinh", -1)
const _hoisted_29 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Dân tộc", -1)
const _hoisted_31 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Khu vực ưu tiên", -1)
const _hoisted_33 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Đối tượng ưu tiên", -1)
const _hoisted_35 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Hộ khẩu thường trú", -1)
const _hoisted_37 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Mã tỉnh (Tp)", -1)
const _hoisted_39 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Mã huyện (quận)", -1)
const _hoisted_41 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Điện thoại liên lạc", -1)
const _hoisted_43 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Email", -1)
const _hoisted_45 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Địa chỉ liên hệ", -1)
const _hoisted_47 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_48 = { class: "col-12" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "utc-subtitle" }, "Nơi học THPT", -1)
const _hoisted_50 = { class: "col-12 md:col-1" }
const _hoisted_51 = { class: "subject-title" }
const _hoisted_52 = { class: "subject-title-text font-medium text-blue-500 underline" }
const _hoisted_53 = { class: "col-12 md:col-2 flex flex-column gap-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", {
  for: "highSchool",
  class: "font-medium"
}, "Tên trường", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("small", { id: "highSchool-help" }, null, -1)
const _hoisted_56 = { class: "col-12 md:col-4 flex flex-column gap-2" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", {
  for: "highSchool",
  class: "font-medium"
}, [
  /*#__PURE__*/_createTextVNode(" Địa chỉ"),
  /*#__PURE__*/_createElementVNode("small", null, [
    /*#__PURE__*/_createElementVNode("i", null, " (huyện (quận), tỉnh (thành phố)) ")
  ])
], -1)
const _hoisted_58 = { class: "col-12 md:col-2 flex flex-column gap-2" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", {
  for: "highSchool",
  class: "font-medium"
}, "Mã tỉnh (Tp)", -1)
const _hoisted_60 = { class: "col-12 md:col-2 flex flex-column gap-2" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", {
  for: "highSchool",
  class: "font-medium"
}, "Mã huyện (quận)", -1)
const _hoisted_62 = { class: "col-12 md:col-1 flex flex-column gap-2" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", {
  for: "highSchool",
  class: "font-medium"
}, "Mã trường", -1)
const _hoisted_64 = { class: "col-12" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "utc-subtitle" }, "Kết quả học tập", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Năm tốt nghiệp", -1)
const _hoisted_67 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Điểm ielts (nếu có)", -1)
const _hoisted_69 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Ngày cấp chứng chỉ ielts", -1)
const _hoisted_71 = { class: "col-12 md:col-8 border-bottom-1 border-blue-200" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-4 border-bottom-1 border-blue-200 font-medium" }, "Điểm trung bình 3 năm THPT", -1)
const _hoisted_73 = { class: "col-12 md:col-3" }
const _hoisted_74 = { class: "subject-title" }
const _hoisted_75 = { class: "subject-title-text font-medium" }
const _hoisted_76 = { class: "col-12 md:col-3 flex flex-row gap-6" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "text-blue-500" }, "Lớp 10", -1)
const _hoisted_78 = { class: "font-medium" }
const _hoisted_79 = { class: "col-12 md:col-3 flex flex-row gap-6" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "text-blue-500" }, "Lớp 11", -1)
const _hoisted_81 = { class: "font-medium" }
const _hoisted_82 = { class: "col-12 md:col-3 flex flex-row gap-6" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "text-blue-500" }, "Lớp 12", -1)
const _hoisted_84 = { class: "font-medium" }

import Divider from "primevue/divider";
    import Image from 'primevue/image';
    import { registrationStatusSource } from "@/constants/status";
    import Button from 'primevue/button';
    import { useRouter } from "vue-router";
    const width = 320;

export default /*#__PURE__*/_defineComponent({
  __name: 'CommonDetail',
  props: {
    registration: {},
    updateFile: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

    
    const getClassName = (code: string) => {
        return { 'CLASS_10': 'Lớp 10', 'CLASS_11': 'Lớp 11', 'CLASS_12': 'Lớp 12' }[code];
    }

    const getStatusName = (status: string) => {
        const item = registrationStatusSource.find(x => x.value == status);
        if (item) {
            return item.label;
        }
        return '';
    }
    const router = useRouter();
    
return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Divider), {
        align: "center",
        type: "solid"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      ((_ctx.registration?.modifyToken || _ctx.registration?.updateAttachmentsToken) && !_ctx.updateFile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.registration?.modifyToken && _ctx.registration?.modifyToken?.token)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_router_link, {
                    to: { name: 'edit', params: { token: _ctx.registration?.modifyToken?.token } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Sửa hồ sơ ")
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.registration?.updateAttachmentsToken && _ctx.registration?.updateAttachmentsToken?.token)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_router_link, {
                    to: { name: 'update-files', params: { token: _ctx.registration?.updateAttachmentsToken?.token } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cập nhật minh chứng ")
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.registration?.code), 1),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("span", null, _toDisplayString(_ctx.registration?.paymentStatus == 'CHUA_THANH_TOAN' ? 'Chưa thanh toán' : 'Đã thanh toán'), 1)
    ]),
    (_ctx.registration?.paymentStatus == 'CHUA_THANH_TOAN' && _ctx.registration?.qrCode)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(Image), {
              src: _ctx.registration?.qrCode
            }, null, 8, ["src"])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("span", {
        innerHTML: _ctx.registration?.statusReason ?
            _ctx.registration?.statusReason : '-'
      }, null, 8, _hoisted_15)
    ]),
    _hoisted_16,
    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.registration?.fullName), 1),
    _hoisted_18,
    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.registration?.identityNumber), 1),
    _hoisted_20,
    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.registration?.dateGranted), 1),
    _hoisted_22,
    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.registration?.placeOfGranted), 1),
    _hoisted_24,
    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.registration?.gender), 1),
    _hoisted_26,
    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.registration?.birthday), 1),
    _hoisted_28,
    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.registration?.placeOfBirth), 1),
    _hoisted_30,
    _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.registration?.nation), 1),
    _hoisted_32,
    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.registration?.priorityArea?.text), 1),
    _hoisted_34,
    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.registration?.priorityObject?.text ?
            _ctx.registration?.priorityObject?.text : '-'), 1),
    _hoisted_36,
    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.registration?.permanentAddress), 1),
    _hoisted_38,
    _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.registration?.provinceCode), 1),
    _hoisted_40,
    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.registration?.districtCode), 1),
    _hoisted_42,
    _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.registration?.mobile), 1),
    _hoisted_44,
    _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.registration?.email), 1),
    _hoisted_46,
    _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.registration?.address), 1),
    _createElementVNode("div", _hoisted_48, [
      _createVNode(_unref(Divider), {
        align: "center",
        type: "solid"
      }, {
        default: _withCtx(() => [
          _hoisted_49
        ]),
        _: 1
      })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registration?.placeOfStudies, (placeOfStudy, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-12 h-auto flex flex-row flex-wrap border-bottom-1 border-blue-200",
        key: index
      }, [
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("span", _hoisted_52, _toDisplayString(getClassName(placeOfStudy.code)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _hoisted_54,
          _createTextVNode(" " + _toDisplayString(placeOfStudy.highSchool?.text) + " ", 1),
          _hoisted_55
        ]),
        _createElementVNode("div", _hoisted_56, [
          _hoisted_57,
          _createTextVNode(" " + _toDisplayString(placeOfStudy.highSchool?.metadata.address), 1)
        ]),
        _createElementVNode("div", _hoisted_58, [
          _hoisted_59,
          _createTextVNode(" " + _toDisplayString(placeOfStudy.highSchool?.metadata.provinceCode), 1)
        ]),
        _createElementVNode("div", _hoisted_60, [
          _hoisted_61,
          _createTextVNode(" " + _toDisplayString(placeOfStudy.highSchool?.metadata.districtCode), 1)
        ]),
        _createElementVNode("div", _hoisted_62, [
          _hoisted_63,
          _createTextVNode(" " + _toDisplayString(placeOfStudy.highSchool?.metadata.code), 1)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_64, [
      _createVNode(_unref(Divider), {
        align: "center",
        type: "solid"
      }, {
        default: _withCtx(() => [
          _hoisted_65
        ]),
        _: 1
      })
    ]),
    _hoisted_66,
    _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.registration?.graduationYear), 1),
    _hoisted_68,
    _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.registration?.ieltsMark ? _ctx.registration?.ieltsMark :
            '-'), 1),
    _hoisted_70,
    _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.registration?.ieltsDate ? _ctx.registration?.ieltsDate :
            "-"), 1),
    _hoisted_72,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registration?.subjectMarks, (subject, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-12 h-auto flex flex-row flex-wrap border-bottom-1 border-blue-200",
        key: index
      }, [
        _createElementVNode("div", _hoisted_73, [
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("span", _hoisted_75, "Môn " + _toDisplayString(subject.title), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_76, [
          _hoisted_77,
          _createElementVNode("div", _hoisted_78, _toDisplayString(subject.class10), 1)
        ]),
        _createElementVNode("div", _hoisted_79, [
          _hoisted_80,
          _createElementVNode("div", _hoisted_81, _toDisplayString(subject.class11), 1)
        ]),
        _createElementVNode("div", _hoisted_82, [
          _hoisted_83,
          _createElementVNode("div", _hoisted_84, _toDisplayString(subject.class12), 1)
        ])
      ]))
    }), 128)),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})